import SectionTitle from "./SectionTitle";

const points = [
  { icon: "ri-shield-check-fill", title: "PAGCOR Licensed", body: "Ace96au operates under the Philippine Amusement and Gaming Corporation (PAGCOR) — a regulator frequently cited across Asia-facing operations and commonly referenced in offshore jurisdictional oversight frameworks." },
  { icon: "ri-global-line", title: "Curacao Gaming Authority", body: "CGA-style licensing supports multi-region operational narratives aligned with compliance positioning. Internationally recognised and trusted by players across Australia and Asia." },
  { icon: "ri-flag-line", title: "Exclusively for Australian Players", body: "Designed with Australian player preferences in mind, offering seamless access to trending and popular game categories tailored to local tastes, with AUD as the primary currency." },
  { icon: "ri-verified-badge-line", title: "RNG Certified by iTech Labs & BMM Testlabs", body: "All 4000+ games operate on independently certified RNG technology by iTech Labs and BMM Testlabs, ensuring fair, unbiased, and transparent outcomes at all times." },
  { icon: "ri-lock-fill", title: "256-Bit SSL Encryption", body: "Sessions are protected with modern TLS/SSL encryption standards from end to end. Your personal data and financial transactions are always fully secured." },
  { icon: "ri-computer-line", title: "Refined & Intuitive Platform", body: "A clean, modern interface with structured categories and smooth navigation for effortless browsing and gameplay discovery. Optimised for both desktop and mobile." },
  { icon: "ri-test-tube-line", title: "ThreatMetrix Fraud Prevention", body: "Advanced fraud prevention powered by ThreatMetrix and Iovation device security. Every transaction and login is monitored to protect your account." },
  { icon: "ri-heart-fill", title: "Responsible Gaming Commitment", body: "Ace96au provides responsible gaming tools and guidance to support a safe, balanced, and controlled entertainment experience. 18+ only. Gamble responsibly. Free support: 1800 858 858." },
  { icon: "ri-award-line", title: "eCOGRA Player Protection", body: "eCOGRA certified for player protection. TST technical testing and BMM Testlabs game auditing ensure every game meets the highest standards of fairness and integrity." },
];

export default function SecurityLicence() {
  return (
    <section id="security" className="py-12">
      <SectionTitle>Security and Licence</SectionTitle>

      <p className="text-slate-300 leading-relaxed mb-8 text-sm">
        Step into the world of Ace96au knowing your security is locked tight from the moment you register. Fully licensed under PAGCOR and the Curacao Gaming Authority, Ace96au gives Australian players the freedom to enjoy 4000+ games without fear or doubt. All games are RNG-certified by iTech Labs and BMM Testlabs. All transactions are SSL-encrypted. Certified by eCOGRA for player protection and ThreatMetrix for fraud prevention.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-8">
        {points.map((p, i) => (
          <div
            key={i}
            className="glass-card rounded-2xl p-5 transition-all duration-300 group cursor-default"
          >
            <div
              className="w-11 h-11 flex items-center justify-center rounded-xl mb-4 transition-all duration-300 group-hover:scale-110"
              style={{
                background: "linear-gradient(135deg, rgba(16,92,232,0.25), rgba(16,92,232,0.12))",
                border: "1px solid rgba(16,92,232,0.25)",
              }}
            >
              <i className={`${p.icon} text-xl`} style={{ color: "#105CE8" }}></i>
            </div>
            <strong className="text-white font-semibold text-sm block mb-2">{p.title}</strong>
            <p className="text-slate-400 text-xs leading-relaxed">{p.body}</p>
          </div>
        ))}
      </div>

      {/* App download banner removed */}
    </section>
  );
}
